import React from 'react';
import AtelierImage from '../assets/bio/bio.jpg'

const Bio = () => {
    return (
      <div className="flex flex-col md:flex-row items-center md:items-start justify-center md:justify-between py-16 md:py-24">
        
        {/* Left Column: Image */}
        <div className="w-full md:w-1/2 ">
          <img
            src={AtelierImage}
            alt="Bio"
            className="w-full h-full object-cover rounded-md"
          />
        </div>
        
        {/* Right Column: Text and Button */}
        <div className="w-full md:w-1/2 mt-36 p-8 font-serif text-center md:text-left tracking-wider">
          <p className="text-2xl font-thin  text-center mb-4 opacity-50">H ΣΧΕΔΙΑΣΤΡΙΑ</p>
          <p className="text-2xl font-thin  text-center mb-4 opacity-50">Τζένη Καραευθυμίου</p>
          <p className="text-gray-600 text-center pt-6 mb-4 leading-loose">
            Από το νεαρό της ηλικία της η Τζένη έχοντας ιδιαίτερη τάση στο χώρο της μόδας
            και πάθος για μοναδικές δημιουργίες, σχεδίαζε ρούχα με πολύ στυλ και γούστο.
          </p>
          <p className="text-gray-600 text-center pt-3 mb-4 leading-loose">
            Σπούδασε στον όμιλο ΄΄ΔΗΜΗΤΡΕΛΗ΄΄ και αποφοίτησε ως Designer – Montelist – Patronist - Stylist.
            Μετά το πέρας των σπουδών της και για πολλά χρόνια συνεργάστηκε με μεγάλες εταιρίες στην κατασκευή
            και σχεδιασμό του γυναικείου ενδύματος. Η πολυετή της ενασχόληση στο σχεδιαστικό τμήμα ως designer
            haute couture, η παρακολούθηση ειδικών σεμιναρίων με εξειδίκευση  στην κατασκευή νυφικών φορεμάτων , 
            αλλά και η συνεχή ενημέρωση για τις τάσεις και προτάσεις των ξένων οίκων, την κατέστησε ως μία ξεχωριστή
            δημιουργό υψηλής ραπτικής βραδινών και νυφικών φορεμάτων.
          </p>
          <p className="text-gray-600 text-center pt-3 mb-4 leading-loose">
            Έχοντας  ως όνειρο την απόκτηση του δικού της atelier, και βάζοντάς το ως στόχο, το 2013
            η Τζένη δημιούργησε έναν ιδιαίτερα κομψό και ζεστό χώρο το Atelier Jenny.
            Με μεγάλη ποικιλία σχεδίων, με πρώτης  ποιότητας υφάσματα, με άριστη κατασκευή και ραφή,
            με πολύ φαντασία και αγάπη για λαμπερές δημιουργίες  αλλά και με σεβασμό στην επιθυμία της κάθε  πελάτισσας,
            η Τζένη μπορεί να καταστήσει  το ονειρεμένο νυφικό φόρεμα κάθε κοπέλας, πραγματικότητα.
          </p>
        </div>
      </div>
    );
  };
  
  export default Bio;